export function toKnownError(unknownError: unknown): Error {
  // If it's already an Error instance, return it directly
  if (unknownError instanceof Error) {
    return unknownError;
  }

  if (unknownError === undefined) {
    return new Error('Rejected with undefined');
  }
  if (unknownError === null) {
    return new Error('Rejected with null');
  }

  if (typeof unknownError === 'string') {
    return new Error(unknownError);
  }

  try {
    const errorMessage =
      typeof unknownError === 'object' && 'message' in unknownError
        ? String(unknownError.message)
        : `Unknown error type: ${typeof unknownError}`;

    return new Error(errorMessage);
  } catch (e) {
    return new Error(`Unknown error type: ${typeof unknownError}`);
  }
}
